module.exports = __webpack_public_path__ + "static/media/bg.mountain.080a3a04.png";